// Bilingual helper mirroring the deployed build's `l(ar, en)` / `o(ar, en)` pattern.
// The app is Arabic-first (RTL) with English fallbacks throughout.

export type Lang = "ar" | "en";

export function pick(lang: Lang, ar: string, en: string): string {
  return lang === "ar" ? ar : en;
}

export function isRTL(lang: Lang): boolean {
  return lang === "ar";
}
